import './Custom.css';const custom = "_custom_sqcd6_1";
const styles = {
  custom
};
export {
  custom,
  styles as default
};
